import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const ifAuthenticated = (to, from, next) => {
  if (!localStorage.getItem('userData'))
    next({
      path: '/login'
    })
  else
    next()
};
const NotAuthenticated = (to, from, next) => {
  if (localStorage.getItem('userData'))
    next({
      path: '/'
    })
  else next()
};


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'dashboard-ecommerce',
      component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    // {
    //   path: '/dashboard/analytics',
    //   name: 'dashboard-analytics',
    //   component: () => import('@/views/dashboard/analytics/Analytics.vue'),
    // },
    {
      path: '/dashboard/ecommerce',
      name: 'dashboard-ecommerce',
      component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    },
    {
      path: '/stock',
      name: 'stock',
      component: () => import('@/views/product/stock/Stock.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'stock',
        breadcrumb: [
          {
            text: 'Liste des produits',
            active: true,
          },
        ],
      },
    },
    {
      path: '/stock/add-stock',
      name: 'add-stock',
      component: () => import('@/views/product/stock/AddStock.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'stock',
        breadcrumb: [
          {
            text: 'Ajouter un produit',
            active: true,
          },
        ],
      },
    },
    {
      path: '/stock/edit-stock',
      name: 'edit-stock',
      component: () => import('@/views/product/stock/EditStock.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'stock',
        breadcrumb: [
          {
            text: 'Modifer un produit',
            active: true,
          },
        ],
      },
    },


    {
      path: '/client',
      name: 'client',
      component: () => import('@/views/client/Clients.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Client',
        breadcrumb: [
          {
            text: 'Liste des clients',
            active: true,
          },
        ],
      },
    },
    {
      path: '/client/add-client',
      name: 'add-client',
      component: () => import('@/views/client/AddClient.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Client',
        breadcrumb: [
          {
            text: 'Ajouter un client',
            active: true,
          },
        ],
      },
    },
    {
      path: '/client/edit-client',
      name: 'edit-client',
      component: () => import('@/views/client/EditClient.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Client',
        breadcrumb: [
          {
            text: 'Modifier un client',
            active: true,
          },
        ],
      },
    },



    {
      path: '/supplier',
      name: 'supplier',
      component: () => import('@/views/supplier/Supplier.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Founisseur',
        breadcrumb: [
          {
            text: 'Liste des founisseur',
            active: true,
          },
        ],
      },
    },
    {
      path: '/supplier/add-supplier',
      name: 'add-supplier',
      component: () => import('@/views/supplier/AddSupplier.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Founisseur',
        breadcrumb: [
          {
            text: 'Ajouter un founisseur',
            active: true,
          },
        ],
      },
    },
    {
      path: '/supplier/edit-supplier',
      name: 'edit-supplier',
      component: () => import('@/views/supplier/EditSupplier.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Founisseur',
        breadcrumb: [
          {
            text: 'Modifier un founisseur',
            active: true,
          },
        ],
      },
    },



    {
      path: '/prospect',
      name: 'prospect',
      component: () => import('@/views/prospect/Prospect.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Prospect',
        breadcrumb: [
          {
            text: 'Liste des prospect',
            active: true,
          },
        ],
      },
    },
    {
      path: '/prospect/add-prospect',
      name: 'add-prospect',
      component: () => import('@/views/prospect/AddProspect.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Prospect',
        breadcrumb: [
          {
            text: 'Ajouter un prospect',
            active: true,
          },
        ],
      },
    },
    {
      path: '/prospect/edit-prospect',
      name: 'edit-prospect',
      component: () => import('@/views/prospect/EditProspect.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Prospect',
        breadcrumb: [
          {
            text: 'Modifier un prospect',
            active: true,
          },
        ],
      },
    },
    // *****************************************************************SALE**********************************************************//
    {
      path: '/sale/command/edit-command',
      name: 'edit-sale-command',
      component: () => import('@/views/sale/command/EditCommand.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Modifier une commande',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/command',
      name: 'sale-command',
      component: () => import('@/views/sale/command/Command.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Liste des commandes',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/command/add-command',
      name: 'add-sale-command',
      component: () => import('@/views/sale/command/AddCommand.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Ajouter une Commande',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/invoice/sub-invoice',
      name: 'sub-sale-invoice',
      component: () => import('@/views/sale/invoice/SubInvoice.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Liste des reçus',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/invoice/add-invoice',
      name: 'add-sale-invoice',
      component: () => import('@/views/sale/invoice/InvoiceAdd.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Ajouter une facture',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/invoice/invoice',
      name: 'sale-invoice',
      component: () => import('@/views/sale/invoice/Invoice.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Liste des factures',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/invoice/preview-invoice',
      name: 'preview-sale-invoice',
      component: () => import('@/views/sale/invoice/InvoicePreview.vue'),
    },
    {
      path: '/sale/invoice/edit-invoice',
      name: 'edit-sale-invoice',
      component: () => import('@/views/sale/invoice/InvoiceEdit.vue'),
    },
    // {
    //   path: '/sale/sub-invoice/edit-sub-invoice',
    //   name: 'edit-sale-sub-invoice',
    //   component: () => import('@/views/sale/invoice/SubInvoiceEdit.vue'),
    // },
    {
      path: '/sale/sub-invoice/preview-sub-invoice',
      name: 'preview-sale-sub-invoice',
      component: () => import('@/views/sale/invoice/SubInvoicePreview.vue'),
    },
    //***************************************** */ quote
    {
      path: '/sale/quote/add-quote',
      name: 'add-sale-quote',
      component: () => import('@/views/sale/quote/QuoteAdd.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Ajouter une devis',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/quote/quote',
      name: 'sale-quote',
      component: () => import('@/views/sale/quote/Quote.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Liste des devis',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/quote/preview-quote',
      name: 'preview-sale-quote',
      component: () => import('@/views/sale/quote/QuotePreview.vue'),
    },
    {
      path: '/sale/quote/edit-quote',
      name: 'edit-sale-quote',
      component: () => import('@/views/sale/quote/QuoteEdit.vue'),
    },

    // *****************************************************************SHOP**********************************************************//
    {
      path: '/shop/command/edit-command',
      name: 'edit-shop-command',
      component: () => import('@/views/shop/command/EditCommand.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Achat',
        breadcrumb: [
          {
            text: 'Modifier une commande',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shop/command',
      name: 'shop-command',
      component: () => import('@/views/shop/command/Command.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Achat',
        breadcrumb: [
          {
            text: 'Liste des commandes',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shop/purchase-order',
      name: 'shop-purchase-order',
      component: () => import('@/views/shop/command/purchaseOrder.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Achat',
        breadcrumb: [
          {
            text: 'Liste des bons de commandes',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shop/purchase-order/add-purchase-order',
      name: 'shop-add-purchase-order',
      component: () => import('@/views/shop/command/purchaseOrderPreview.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Achat',
        breadcrumb: [
          {
            text: 'Ajouter un bon de commande',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shop/command/add-command',
      name: 'add-shop-command',
      component: () => import('@/views/shop/command/AddCommand.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Achat',
        breadcrumb: [
          {
            text: 'Ajouter une Commande',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shop/invoice/add-invoice',
      name: 'add-shop-invoice',
      component: () => import('@/views/shop/invoice/InvoiceAdd.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Ajouter une facture',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shop/invoice/invoice',
      name: 'shop-invoice',
      component: () => import('@/views/shop/invoice/Invoice.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Vente',
        breadcrumb: [
          {
            text: 'Liste des factures',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shop/invoice/preview-invoice',
      name: 'preview-shop-invoice',
      component: () => import('@/views/shop/invoice/InvoicePreview.vue'),
    },
    {
      path: '/shop/invoice/edit-invoice',
      name: 'edit-shop-invoice',
      component: () => import('@/views/shop/invoice/InvoiceEdit.vue'),
    },
    {
      path: '/shop/quote/add-quote',
      name: 'add-shop-quote',
      component: () => import('@/views/shop/quote/QuoteAdd.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Achat',
        breadcrumb: [
          {
            text: 'Ajouter une devis',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shop/quote/quote',
      name: 'shop-quote',
      component: () => import('@/views/shop/quote/Quote.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Achats',
        breadcrumb: [
          {
            text: 'Liste des devis',
            active: true,
          },
        ],
      },
    },
    {
      path: '/shop/quote/preview-quote',
      name: 'preview-shop-quote',
      component: () => import('@/views/shop/quote/QuotePreview.vue'),
      beforeEnter: ifAuthenticated,
      // meta: {
      //   pageTitle: 'Achats',
      //   breadcrumb: [
      //     {
      //       text: 'Consulter devis',
      //       active: true,
      //     },
      //   ],
      // },
    },
    {
      path: '/shop/quote/edit-quote',
      name: 'edit-shop-quote',
      component: () => import('@/views/shop/quote/QuoteEdit.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Achats',
        breadcrumb: [
          {
            text: 'Modifier devis',
            active: true,
          },
        ],
      },
    },
    // **********************************************************End SHOP **************************************************************
    {
      path: '/categorie',
      name: 'categorie',
      component: () => import('@/views/product/categorie/Categorie.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Categorie',
        breadcrumb: [
          {
            text: 'Categorie',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sub-categorie',
      name: 'subCategorie',
      component: () => import('@/views/product/categorie/SubCategorie.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Sous-catégorie',
        breadcrumb: [
          {
            text: 'Sous-catégorie',
            active: true,
          },
        ],
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('@/views/others/faq/Faq.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'FAQ',
        breadcrumb: [
          {
            text: 'FAQ',
            active: true,
          },
        ],
      },
    },
    {
      path: '/price',
      name: 'price',
      component: () => import('@/views/others/pricing/Pricing.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Offre',
        breadcrumb: [
          {
            text: 'Offre',
            active: true,
          },
        ],
      },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/account-setting/AccountSetting.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'paramètre',
        breadcrumb: [
          {
            text: 'paramètre',
            active: true,
          },
        ],
      },
    },

    // {
    //   path: '/forms/form-element/auto-suggest',
    //   name: 'extensions-auto-suggest',
    //   component: () => import('@/views/forms/form-element/autosuggest/AutoSuggest.vue'),
    //   meta: {
    //     pageTitle: 'Auto Suggest',
    //     breadcrumb: [
    //       {
    //         text: 'Extensions',
    //       },
    //       {
    //         text: 'Auto Suggest',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/forms/form-wizard/FormWizard.vue',
    //   name: 'extensions-auto',
    //   component: () => import('@/views/forms/form-wizard/FormWizard.vue'),
    //   meta: {
    //     pageTitle: 'Auto Suggest',
    //     breadcrumb: [
    //       {
    //         text: 'Extensions',
    //       },
    //       {
    //         text: 'Auto Suggest',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/table/bs-table',
    //   name: 'table-bs-table',
    //   component: () => import('@/views/table/bs-table/Table.vue'),
    //   meta: {
    //     pageTitle: 'BS Table',
    //     breadcrumb: [
    //       {
    //         text: 'Table',
    //       },
    //       {
    //         text: 'BS Table',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/table/vue-good-table',
    //   name: 'table-good-table',
    //   component: () => import('@/views/table/vue-good-table/GoodTable.vue'),
    //   meta: {
    //     pageTitle: 'Good Table',
    //     breadcrumb: [
    //       {
    //         text: 'Table',
    //       },
    //       {
    //         text: 'Good Table',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/second-page',
    //   name: 'second-page',
    //   component: () => import('@/views/SecondPage.vue'),
    //   meta: {
    //     pageTitle: 'Second Page',
    //     breadcrumb: [
    //       {
    //         text: 'Second Page',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/components/modal',
    //   name: 'components-modal',
    //   component: () => import('@/views/modal/Modal.vue'),
    //   meta: {
    //     pageTitle: 'Modal',
    //     breadcrumb: [
    //       {
    //         text: 'Components',
    //       },
    //       {
    //         text: 'Modal',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/Login.vue'),
      beforeEnter: NotAuthenticated,

      meta: {
        layout: 'full',
      },
    },
    {
      path: '/ForgotPassword',
      name: 'forgot-password',
      component: () => import('@/views//auth/ForgotPassword.vue'),
      beforeEnter: NotAuthenticated,

      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      beforeEnter: NotAuthenticated,

      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})



export default router
